module.exports = __webpack_public_path__ + "img/campaignProgressState.0bb7fbf1.svg";